<template>
  <div class="appManage">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <!-- tab应用管理 -->
    <div class="tabContent manageArea boxs">
      <!-- tab应用管理-筛选框 -->
      <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
        <template slot="otherCom">

          <el-form-item>
            <el-input
                    v-model="searchForm.params.appName"
                    placeholder="输入应用名称"
                    @keyup.enter.native="handleSearch"
                    maxlength="30" size="medium" clearable
                    @input="e => searchForm.params.appName = validForbid(e)"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-input
                    v-model="searchForm.params.packageName"
                    placeholder="输入包名"
                    @keyup.enter.native="handleSearch"
                    maxlength="60" size="medium" clearable
                    @input="e => searchForm.params.packageName = validForbid(e)"
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-select
                    v-model="searchForm.params.client"
                    placeholder="选择客户端"
                    clearable filterable
            >
              <!-- <el-option label="全部客户端" value=""></el-option> -->
              <el-option
                      v-for="item in clientOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="searchForm.params.status"
                       placeholder="选择状态"
                       clearable filterable
            >
              <!-- <el-option label="全部状态" value=""></el-option> -->
              <el-option
                      v-for="item in statusOptions"
                      :key="item.id"
                      :label="item.status"
                      :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

        </template>
      </sr-filter>

      <!-- tab应用管理-表格 -->
      <div class="botTable tableTheadGray boxs">
        <div class="tableTop">
          <span class="leTableTit">应用列表</span>
          <div class="rightBox">
            <!-- 发布应用按钮 -->
            <el-button @click="handleAddDialog()" class="greenBtn" icon="el-icon-plus" size="small">发布应用</el-button>
          </div>
        </div>
        <el-table :data="tableData"
                  ref="multipleTable"
                  style="width: 100%;"
                  max-height="600"
                  border
                  fit
                  highlight-current-row
                  tooltip-effect="dark"
        >
          <!-- 这是列表前面的多选框 -->
          <!-- <el-table-column type="selection" align="center" width="35"></el-table-column> -->

          <el-table-column label="应用名称" prop="APP_NAME" min-width="160" header-align="left" align="left"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click="showDetailPage(scope)" 
                    class="greenText" 
                    style="font-size:14px;cursor:pointer;"
              >
                  {{scope.row.APP_NAME}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="包名" prop="PACKAGE_NAME" min-width="240" header-align="left" align="left"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="客户端" prop="CLIENT" width="100" header-align="left" align="left"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-size:14px;">
                {{scope.row.CLIENT | clientFilter}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="当前最新版本" prop="VERSION" min-width="110" header-align="left" align="left"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="状态" prop="STATUS" width="90" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- 无效(橙色)，有效(青色) -->
              <span :class="[{orangeText:scope.row.STATUS=='0'},{lightGText:scope.row.STATUS=='1'}]">
                {{scope.row.STATUS | statusFilter}}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="CREATE_TIME" width="160" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="过期日期" prop="OVERDUE" width="160" header-align="center" align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column label="操作" fixed="right" width="180" header-align="center" align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="showEditDialog(scope)" class="greenText"
                         type="text" title="编辑"
              >编辑
              </el-button>
              <!-- <el-button @click="showPublishVersionDialog(scope)" class="greenText"
                         type="text" title="发布新版本"
              >发布新版本
              </el-button> -->
              <el-button @click="showDeleteDialog(scope)" class="orangeText"
                         type="text" title="注销"
              >注销
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox boxs">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>

      </div>

    </div>

   


    <!-- 弹窗(新建、编辑)-start -->
    <el-dialog width="520px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="false">
      <el-form ref="form" :rules="rules" :model="postForm" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传新版本">
              <el-upload
                style="display:inline-block"
                action=""
                :show-file-list="false"
                :before-upload="beforeUploadFile"
                :on-success="handleUploadFileSuccess"
                :on-error="handleUploadFileError"
                class="upload-demo"
                ref="upload"
                :http-request="uploadSectionFile"
                >
                <el-button size="small" type="primary">上传新版本</el-button>
                <!-- <el-button style="margin-left: 10px;" size="small" icon="el-icon-upload2" type="success" @click="submitUpload">导入</el-button> -->
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="应用名称" prop="appName">
              <el-input
                      v-model="postForm.appName"
                      placeholder="请输入应用名称"
                      maxlength="30" clearable
                      @input="e => postForm.appName = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        
        <el-row>
          <el-col :span="24">
            <el-form-item label="包名" prop="packageName">
              <el-input
                      v-model="postForm.packageName"
                      placeholder="请输入包名"
                      maxlength="60" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 1230添加版本更新 -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="应用市场" prop="marketId">
              <el-select 
                      v-model="postForm.marketId" 
                      placeholder="请选择应用市场" 
                      filterable clearable
              >
                  <el-option label="蒲公英" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="版本号" prop="version">
              <el-input
                      v-model="postForm.version"
                      placeholder="请输入版本号"
                      maxlength="30" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="更新类型" prop="updateType">
              <el-radio v-model="postForm.updateType"
                        label="1">
                  强制更新
              </el-radio>
              <el-radio v-model="postForm.updateType"
                        label="2">
                  自选更新
              </el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="更新内容" prop="updateContent">
              <el-input
                      v-model="postForm.updateContent"
                      placeholder="请输入更新内容，不超过100个字符"

                      maxlength="100"
                      type="textarea"
                      rows="4"
                      resize="none"
                      style="width: 90%; font-size: 12px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="note">
              <el-input
                      v-model="postForm.note"
                      placeholder="请输入相关描述"
                      maxlength="50" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户端" prop="client">
              <el-radio v-model="postForm.client"
                        label="1">
                  ANDROID
              </el-radio>
              <el-radio v-model="postForm.client"
                        label="2">
                  IOS
              </el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="过期日期" prop="overdue">
              <el-date-picker
                v-model="postForm.overdue"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="最新版本下载地址" prop="updateLatestUrl">
              <el-input
                      v-model="postForm.updateLatestUrl"
                      placeholder="请输入最新版本下载地址"
                      maxlength="200" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="状态" prop="status">
              <el-select 
                      v-model="postForm.status" 
                      placeholder="请选择状态" 
                      filterable clearable
              >
                  <el-option 
                          v-for="item in statusOptions" 
                          :key="item.id" 
                          :label="item.status" 
                          :value="item.id"
                  >
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="应用二维码" prop="qrcodeImageId">
              <el-upload
                      class="avatar-uploader"
                      action=""
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="handleUploadSuccess"
                      :on-error="handleUploadError"
                      :http-request="onUpload"
              >
                <template
                        v-if="(postForm && postForm.qrcodeImageId && postForm.qrcodeImageId!= '') || uploadedFileId && uploadedFileId!= ''">
                  <img v-if="postForm.qrcodeImageId"
                       :src="$variable.getFile(postForm.qrcodeImageId)"
                       class="avatar">
                  <img v-else-if="uploadedFileId"
                       :src="$variable.getFile(uploadedFileId)"
                       class="avatar">
                </template>
                <template v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer flex-col">
          <div class="flex-row jus-c">
              <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
              <button @click="validateForm" class="butStyle refuseOBtn">确 定</button>
          </div>
      </span>

    </el-dialog>
    <!-- 弹窗(新建、编辑)-end -->





    <!-- 发布新版本弹窗-start -->
    <el-dialog width="460px" :title="'发布新版本'" :visible.sync="publishVersionDialogVisible"
               @close="closePublishVersionDialog"
               :before-close="beforeClosePublishVersion" :close-on-click-modal=false :show-close="true">
      <el-form ref="publishVersionForm" :rules="checkRules" :model="publishVersionForm" label-width="94px">

        <el-row>
          <el-col :span="24">
            <el-form-item label="当前应用" prop="current_app_name">
              <el-input
                      v-model="publishVersionForm.current_app_name"
                      placeholder="请输入当前应用"
                      maxlength="30" clearable
                      :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="应用市场" prop="marketId">
              <el-select 
                      v-model="publishVersionForm.marketId" 
                      placeholder="请选择应用市场" 
                      filterable clearable
              >
                  <el-option label="蒲公英" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="版本号" prop="version">
              <el-input
                      v-model="publishVersionForm.version"
                      placeholder="请输入版本号"
                      maxlength="30" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="更新类型" prop="updateType">
              <el-radio v-model="publishVersionForm.updateType"
                        label="1">
                  强制更新
              </el-radio>
              <el-radio v-model="publishVersionForm.updateType"
                        label="2">
                  自选更新
              </el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="更新内容" prop="updateContent">
              <el-input
                      v-model="publishVersionForm.updateContent"
                      placeholder="请输入更新内容，不超过100个字符"

                      maxlength="100"
                      type="textarea"
                      rows="4"
                      resize="none"
                      style="width: 90%; font-size: 12px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="描述" prop="note">
              <el-input
                      v-model="publishVersionForm.note"
                      placeholder="请输入相关描述"
                      maxlength="50" clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>


      </el-form>

      <span slot="footer" class="dialog-footer flex-row jus-c">
        <button @click="beforeClosePublishVersion" class="butStyle cancelBtn">取 消</button>
        <button @click="validatePublishVersionForm" class="butStyle refuseOBtn">保 存</button>
      </span>
    </el-dialog>
    <!-- 发布新版本弹窗-end -->

  </div>
</template>


<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';
  import {formatDate} from '@/utils/dateFormatter';

  import {
    uploadFile
  } from '@/api/common.js';
  import {
    // 查询列表
    getAppListAPI,
    // 查询app信息
    getAppInfoByIdAPI,
    // 发布新应用
    addAppAPI,
    // 修改应用
    editAppAPI,
    // 注销应用
    cancelAppAPI,
    // 发布新版本
    publishVersionAPI,
    //安装包检测
    checkPackageAPI,
    //发布新版本
    publishNewVersionAPI
  } from '@/api/System/appManage.js'



  // 获取默认日期：当前日期加五年
  let getDefaultDate = function() {
      let date = new Date();
      date.setFullYear(new Date().getFullYear()+5)
      return formatDate(date, 'yyyy-MM-dd');
  }

  // 弹窗的数据
  const defaultPostForm = {
    id: '', 
    appName: '', //应用名称
    packageName: '', //包名
    client: '', //客户端：1-ANDROID Q，2-IOS
    overdue: getDefaultDate(), //过期日期(当前日期加五年)
    updateLatestUrl: '', //最新版本下载地址
    status: '', //状态：0-无效，1-有效
    qrcodeImageId: '', //应用二维码图片id
    //1230
    marketId: '', //应用市场
    version: '', //版本号
    updateType: '1', //更新类型: 1-强制更新 Q，2-自选更新
    updateContent: '', //更新内容
    note: '', //描述
  }

  // 发布新版本弹窗数据
  const defaultPublishVersionForm = {
    current_app_name: '', //当前应用(名称)

    appId: '', 
    marketId: '', //应用市场
    version: '', //版本号
    updateType: '1', //更新类型: 1-强制更新 Q，2-自选更新
    updateContent: '', //更新内容
    note: '', //描述
  }

  // 搜索表格的条件-筛选栏
  const defaultSearchForm = {
    current: 1, //当前页码
    size: 10, //每页条数
    params: {
      appName: '', //应用名称
      packageName: '', //包名
      client: '', //客户端：1-ANDROID Q，2-IOS
      status: '', //状态：0-无效，1-有效
    }
  }

  export default {
    name: "AppManage",
    components: {
      TitleBox,
      SrFilter
    },
    filters: {
      // 状态过滤器
      statusFilter (status) {
        const statusMap = {
          '0': '无效',
          '1': '有效',
        }
        return statusMap[status]
      },
      // 客户端过滤器
      clientFilter (client) {
        const clientMap = {
          '1': 'ANDROID',
          '2': 'IOS'
        }
        return clientMap[client]
      }
    },
    data() {
      return {
        //标题
        topTitle: {
          title: '应用管理',
          subTit: ''
        },

        // 表格搜索条件
        searchForm: Object.assign({}, defaultSearchForm),
        // 客户端类型
        clientOptions: [
          {id: '1', name: 'ANDROID'},
          {id: '2', name: 'IOS'}
        ],
        // 状态
        statusOptions: [
          {id: '0', status: '无效'},
          {id: '1', status: '有效'}
        ],

        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,

        // 弹窗数据
        postForm: Object.assign({}, defaultPostForm),
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        // 弹窗标题
        dialogMap: {
          add: '发布新应用',
          edit: '编辑应用'
        },
        dialogTitle: '',
        uploadedFileId: null,
        // 弹窗校验规则
        rules: {
          appName: [{required: true, message: '请输入应用名称', trigger: 'blur'}],
          packageName: [{required: true, message: '请输入包名', trigger: 'blur'}],
          client: [{required: true, message: '请选择客户端', trigger: 'blur'}],
          overdue: [{required: true, message: '请选择过期日期', trigger: 'blur'}],
          // updateLatestUrl: [{required: true, message: '请输入最新版本下载地址', trigger: 'blur'}],
          status: [{required: true, message: '请选择状态', trigger: 'blur'}],
          qrcodeImageId: [{required: false, message: '请上传应用二维码', trigger: 'blur'}],
          marketId: [{required: true, message: '请选择应用市场', trigger: 'blur'}],
          version: [{required: true, message: '请输入版本号', trigger: 'blur'}],
          updateType: [{required: true, message: '请选择更新类型', trigger: 'blur'}],
          updateContent: [{required: true, message: '请输入更新内容', trigger: 'blur'}],
          note: [{required: false, message: '请输入相关描述', trigger: 'blur'}],
        },


        // 发布新版本窗口是否显示
        publishVersionDialogVisible: false,
        // “发布新版本”弹窗数据
        publishVersionForm: Object.assign({}, defaultPublishVersionForm),
        checkRules: {
          current_app_name: [{required: true, message: '请输入当前应用', trigger: 'blur'}],
          marketId: [{required: true, message: '请选择应用市场', trigger: 'blur'}],
          version: [{required: true, message: '请输入版本号', trigger: 'blur'}],
          updateType: [{required: true, message: '请选择更新类型', trigger: 'blur'}],
          updateContent: [{required: true, message: '请输入更新内容', trigger: 'blur'}],
          note: [{required: false, message: '请输入相关描述', trigger: 'blur'}],
        },
      }
    },
    created() {
      this.loadTableData()
    },
    methods: {
      beforeUploadFile(file) {
        console.log(file)
        // const isLt2M = file.size / 1024 / 1024 < 50;
        // if (!isLt2M) {
        //   this.$message.error('文件大小不能超过 50MB!');
        // }
        // // const check = isLt2M && (isXls || isXlsx);
        // const check = isLt2M ;
        // return check;
      },
      uploadSectionFile(uploadObj){
        let file = uploadObj.file
        let param = new FormData()
        param.append('file', file)
        // FormData 对象
        var form = new FormData();
        checkPackageAPI(param).then(data => {
          let dataList = data.data
          this.postForm.packageName = dataList.packageName
          this.postForm.appName = dataList.appName
          this.postForm.version = dataList.version
          this.postForm.updateLatestUrl = dataList.url
          console.log('bao',this.postForm.packageName);
        }).catch(err => {
          console.log(err)
        })
      },
      // 文件上传成功时的钩子
      handleUploadFileSuccess(res, file) {
        console.log('成功');
      },
      // 文件上传失败时的钩子
      handleUploadFileError(res, file) {
        this.$message.error('文件上传失败！')
        this.$alert('文件上传失败！', '上传失败提示', {
          confirmButtonText: '确定',
          type: 'error',
          showClose: false,
          dangerouslyUseHTMLString: true
        })
      },
      async loadTableData() {
        try {
          const result = await getAppListAPI(this.searchForm);
          // console.log('loadTableData-result:', result)
          this.tableData = result.data.records;
          this.total = result.data.total
        } catch (e) {

        }
      },


      // 列表过滤查询
      handleSearch() {
        this.searchForm.current = 1
        this.loadTableData()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        // this.searchForm = Object.assign({}, defaultSearchForm)
        this.searchForm.params.appName = ''
        this.searchForm.params.packageName = ''
        this.searchForm.params.client = ''
        this.searchForm.params.status = ''
        this.searchForm.current = 1
        this.searchForm.size = 10
        // 获取表格数据
        this.loadTableData()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.loadTableData()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.loadTableData()
      },


      
      // 跳转到应用详情页
      showDetailPage(data) {
        const rowData = JSON.parse(JSON.stringify(data.row));
        // console.log('rowData', rowData)

        this.$router.push({
          path: '/system/appManage/appDetail',
          query: rowData
        })
      },
      handleAddDialog() {
        this.dialogTitle = 'add'
        this.dialogFormVisible = true
        this.postForm = Object.assign({}, defaultPostForm)
      },
      showEditDialog(data) {
        this.dialogTitle = 'edit'
        this.dialogFormVisible = true

        const rowData = JSON.parse(JSON.stringify(data.row));
        console.log('rowData', rowData)

        this.postForm.id = rowData.ID;
        this.postForm.appName = rowData.APP_NAME;
        this.postForm.packageName = rowData.PACKAGE_NAME;
        this.postForm.client = rowData.CLIENT;
        this.postForm.overdue = rowData.OVERDUE;
        this.postForm.updateLatestUrl = rowData.UPDATE_LATEST_URL;
        this.postForm.status = rowData.STATUS;
        this.postForm.qrcodeImageId = rowData.QRCODE_IMAGE_ID;

        this.postForm.version = rowData.VERSION;
      },
      // 弹出“注销”确认框
      showDeleteDialog(data) {

        const rowData = JSON.parse(JSON.stringify(data.row))

        var delParams = {
          id: rowData.ID,
          status: '0',
        }

        var $this = this;
        this.$confirm('确定注销吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            $this.deleteApp(delParams);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消注销操作'
            })
        })

      },
      async deleteApp(params) {
        try {
          await cancelAppAPI(params.id)
          this.$message.success('注销成功')
          this.loadTableData()
        } catch (e) {
          console.log(e)
        }
      },




      // 弹窗关闭前
      beforeClose() {
        this.resetData()
      },
      // 关闭弹窗
      closeDialog() {
        this.resetData()
      },
      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.postForm = Object.assign({}, defaultPostForm)
        this.uploadedFileId = null
      },

      // 验证表单-点击弹窗的“确定”按钮
      validateForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitForm()
          } else {
            this.dialogFormVisible = true
          }
        })
      },
      // 提交表单
      async submitForm() {
        // console.log('提交表单-this.postForm：', this.postForm)
        if (this.dialogTitle === 'add') {
          this.addApp();
        } else if (this.dialogTitle === 'edit') {
          this.editApp();
        }
      },

      async addApp() {
        try {
          // const result = await addAppAPI(this.postForm)
          const result = await publishNewVersionAPI(this.postForm)
          this.$message.success('发布应用成功')
          this.closeDialog()
          this.loadTableData()
        } catch (e) {
          console.log(e)
        }
      },

      async editApp() {
        try {
          // const result = await editAppAPI(this.postForm)
          const result = await publishNewVersionAPI(this.postForm)
          this.$message.success('修改应用成功')
          this.closeDialog()
          this.loadTableData()
        } catch (e) {
          console.log(e)
        }
      },




      // 上传文件之前的钩子(限制文件格式、文件大小),可在此处获取文件id
      beforeUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        // const isLt5M = file.size / 1024 / 1024 < 5;
        const isLt5M = file.size / 1024 / 1024 < 1;

        if (!isJPG && !isPNG) {
          this.$message.error('只能上传jpg/png文件!');
        }
        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        var b = isLt5M && (isJPG || isPNG);
        // console.log(b)
        return b;
      },
      // 上传文件
      onUpload(uploadObj) {
        let file = uploadObj.file
        let param = new FormData()
        param.append('file', file)
        uploadFile(param)
            .then(resp => {
              let uploadedFile = resp.data.uploadedFiles[0];
              this.uploadedFileId = uploadedFile.id
              this.postForm.qrcodeImageId = this.uploadedFileId
            })
            .catch(e => console.log(e))
      },
      // 文件上传成功时的钩子
      handleUploadSuccess(res, file) {
        // console.log('Success-res', res)
        // console.log('Success-file', file)
        // this.postForm.imageUrl = URL.createObjectURL(file.raw);
      },
      // 文件上传失败时的钩子
      handleUploadError(res, file) {
        // console.log('Error-res', res)
        // console.log('Error-file', file)

        this.$message.error('图片上传失败！')
      },








      // 弹出“发布新版本”窗口
      showPublishVersionDialog(data) {
        this.publishVersionDialogVisible = true
        const rowData = JSON.parse(JSON.stringify(data.row))
        console.log('showPublishVersionDialog-rowData', rowData)
        this.publishVersionForm.appId = rowData.ID
        this.publishVersionForm.current_app_name = rowData.APP_NAME
      },
      // “发布新版本”弹窗关闭前
      beforeClosePublishVersion() {
        this.resetPublishVersionData()
      },
      // 关闭“发布新版本”弹窗
      closePublishVersionDialog() {
        this.resetPublishVersionData()
      },
      // 重置“发布新版本”表单
      resetPublishVersionData() {
        this.publishVersionDialogVisible = false
        this.$nextTick(() => {
          this.$refs['publishVersionForm'].clearValidate()
        })
        this.publishVersionForm = Object.assign({}, defaultPublishVersionForm)
      },
      // 验证表单-点击“发布新版本”弹窗的“确定”按钮
      validatePublishVersionForm() {
        this.$refs.publishVersionForm.validate((valid) => {
          if (valid) {
            // 发布新版本
            this.publishVersion();

          } else {
            this.publishVersionDialogVisible = true
          }
        })
      },
      // 发布新版本
      async publishVersion() {
        try {
          const result = await publishVersionAPI(this.publishVersionForm)
          this.$message.success('发布新版本成功')
          this.closePublishVersionDialog()
          this.loadTableData()
        } catch (e) {
          console.log(e)
        }
      },

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  .greenText {
    color: #2DBAA5;
  }

  .lightGText {
    color: #76C819;
  }

  .orangeText {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  // 批量操作
  .batchSel {
    width: 130px;
    margin-right: 5px;
  }

  .orangeBtn {
    color: #FFFFFF !important;
    background-color: #FA6241;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  // 按钮
  .el-button {
  }

  .greenBtn {
    color: #FFFFFF !important;
    background-color: #2DBAA5;

    &:hover {
      background-color: rgb(115, 196, 183);
    }
  }


  .appManage {
    // min-width: 1080px;
  }

  // tab切换-应用管理、会员架构图
  .appManage .tabBox {
    padding-left: 4px;
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .tabBox li {
    float: left;
    width: 80px;
    color: #7F7F7F;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    position: relative;
  }

  .tabBox li.on {
    color: #F99A1A;
  }

  .tabBox li:after {
    content: '';
    position: absolute;
    width: 80px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }

  .tabBox li.on:after {
    background: #F99A1A;
  }


  // tab内容区
  .appManage .tabContent {

  }


  // tab内容区-应用管理
  .appManage .tabContent.manageArea {

  }

  // 应用管理-表格
  .appManage .tabContent.manageArea .botTable {
    width: 100%;
    margin-top: 14px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .leTableTit {
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
  }

  .botTable .tableTop .rightBox {
    width: auto;
    min-width: 200px; //考虑是否删去
    text-align: right;
    display: inline-block;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }




  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


 



  .dialog-littleTitle{
      margin-top: 8px;
      margin-bottom: 8px;
  }
  .dialog-littleTitle-text{
      // width:57px;
      height:16px;
      font-size:12px;
      font-family:Microsoft YaHei;
      font-weight:bold;
      line-height:16px;
      color:rgba(51,51,51,1);
      opacity:1
  }

  .dialog-littleTitle-image{
      height: 10px;
      width: 4px;
      background-color: rgba(250,98,65,1);
      margin-right: 4px;
  }


</style>
